<template>
  <div class="login-page d-flex justify-content-center">
    <div class="card shadow" style="border-radius: 0.75rem">
      <div
        class="card-body shadow login-card-body"
        style="border-radius: 0.75rem"
      >
        <div class="d-flex align-items-center p-5 vector-image">
          <img
            src="@/assets/svg/login-vector.svg"
            alt="login vector"
            class="w-100"
          />
        </div>
        <form
          @submit.prevent="login()"
          class="d-flex flex-column justify-content-center"
        >
          <div class="py-3 mb-3 ">
            <h3 class="font-weight-bold text-dark">Login <br> Vendor Robot</h3>
            <small v-if="errorMessage" class="text-danger">{{ errorMessage }}</small>
          </div>
          <div class="mb-3">
            <div class="mb-3">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'border-danger': $v.username.$error }"
                  placeholder="Username"
                  v-model="username"
                />
                <div class="input-group-append">
                  <div
                    class="input-group-text"
                    :class="{ 'border-danger': $v.username.$error }"
                  >
                    <span class="fas fa-user"></span>
                  </div>
                </div>
              </div>
              <div class="text-danger" v-if="$v.username.$error">
                <small>Username Required</small>
              </div>
            </div>
            <div class="mb-3">
              <div class="input-group">
                <input
                  :type="show.password ? 'text' : 'password'"
                  class="form-control"
                  :class="{ 'border-danger': $v.password.$error }"
                  placeholder="Password"
                  v-model="password"
                />
                <div class="input-group-append">
                  <div
                    class="input-group-text"
                    :class="{ 'border-danger': $v.password.$error }"
                    @click="showPassword()"
                  >
                    <span class="fas" :class="{'fa-eye': !show.password, 'fa-eye-slash': show.password, }"></span>
                  </div>
                </div>
              </div>
              <div class="text-danger" v-if="$v.password.$error">
                <small>Password Required</small>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <input type="checkbox" id="remember" v-model="remember_me"/>
              <label for="remember" class="mb-0 ml-2" style="cursor: pointer">
                Remember Me
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-12 card-button-container">
              <button
                type="submit"
                class="btn btn-danger btn-block rounded-pill d-flex align-items-center justify-content-center"
                :disabled="submitStatus === 'PENDING'"
              >
              <div v-if="loading" class="spinner-border text-light me-2" role="status"></div>
                Login
              </button>
              <hr class="w-100 my-2" />
              <router-link
                :to="{ name: 'Register' }"
                class="btn btn-outline-danger btn-block rounded-pill"
              >
                Register
              </router-link>
              <router-link
                :to="{ name: 'ForgetPassword' }"
                class="text-secondary mt-3"
              >
                <small>Forgot password?</small>
              </router-link>

              <div class="text-secondary mt-3">
                Download our guideline for Robot Vendors 
                <a :href="guideUrl" target="_blank" class="text-danger text-decoration-none">
                  here
                </a>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      username: "",
      password: "",
      remember_me: false,
      submitStatus: null,
      loading: false,
      errorMessage: null,
      show: {
        password: false,
      },
      guideUrl: process.env.VUE_APP_PROD_URL+'guideline/vendor-robot/'
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    showPassword() {
      this.show.password = !this.show.password 
    },
    async login() {
      this.loading = true
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.loading = false
      } else {
        this.submitStatus = "PENDING";
        await this.$store
          .dispatch("login", {
            username: this.username,
            password: this.password,
            remember_me: this.remember_me,
          })
          .then(() => {
            this.loading = false
            this.submitStatus = "OK";
            this.errorMessage = "";
            this.$router.push({ name: "Dashboard" });
          })
          .catch((error) => {
            this.submitStatus = "ERROR";
            this.loading = false
            this.errorMessage = error.response.data.message;
          });
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  background-image: url("~@/assets/svg/wave.svg");
  background-size: cover;
  background-position: center;
}

.card-body {
  border-radius: 0.75rem !important;
  width: 800px;
  display: grid;
  grid-template-columns: 60% 40%;
}
.card-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 805px) {
  .card {
    width: 95%!important;
  }
  .card-body {
    width: 100%;
    grid-template-columns: repeat(2, 50%)!important;
  }
  .vector-image {
    padding: 1rem!important;
  }
}
@media (max-width: 601px) {
  .card {
    width: 325px!important;
  }
  .card-body {
    width: 100%;
    grid-template-columns: 100%!important;
  }
  .vector-image {
    display: none!important;;
  }

}
@media (max-width: 325px) {
  .card {
    width: 100%!important;
    border-radius: 0!important;
  }
}
</style>